import { render } from "./CatalogoSecurityView.vue?vue&type=template&id=77b4a078&scoped=true"
import script from "./CatalogoSecurityView.vue?vue&type=script&lang=js"
export * from "./CatalogoSecurityView.vue?vue&type=script&lang=js"

import "./CatalogoSecurityView.vue?vue&type=style&index=0&id=77b4a078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b4a078"]])

export default __exports__